import { Component, HostBinding, inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-dialog-header",
  templateUrl: "./dialog-header.component.html",
  styleUrls: ["./dialog-header.component.scss"],
})
export class DialogHeaderComponent {
  @HostBinding("class") class = "dialog-header";

  matDialog = inject(MatDialogRef);

  close() {
    this.matDialog.close();
  }
}
